/************
 * List Tab Detail with right hand properties drawer
 * File Name ...: agencysettings.components.ts
 * Generated By : ianday on 10/10/23
 * Date ........: 10/10/23
 /************/

import { Component, OnInit, ViewChild, HostListener, AfterContentInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Settings } from '../../../services/settings';
import { Agencies } from '../../../models/agencies';
import { AgenciesService } from '../../../services/agencies.service';
import { ValidationResult } from '../../../models/validation-result';
import {
	ConfirmDialogComponent,
	ConfirmDialogModel
} from '../../../components/shared/confirmation-dialog/confirmation-dialog.component';
import { MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import { TransactionHistoryService } from '../../../services/transactionhistory.service';
import { TransactionHistoryComponent } from '../../../components/transaction-history/transaction-history';
import { DwUtils } from '../../../components/utils/dw-utils';

@Component({
	selector: 'app-agencysettings',
	templateUrl: './agencysettings.component.html',
	styleUrls: ['./agencysettings.component.css']
})
export class AgencySettingsComponent implements OnInit, AfterContentInit {

	/*** Header / Query Strip Variables ****/
	public formTitle = 'Agencies';
	public pagination: string;

	/*** Editing variables ***/
	public isEditing: boolean | null = false;
	public isAdd: boolean | null = false;
	public records: Agencies[];
	public selectedRecord: Agencies;
	public historyRecord: Agencies;
	public Idx: number | null = -1;
	public strErr: string | null = '';
	public dataSource: MatTableDataSource<Agencies>;
	public renderedData: Array<any>;
	public result: boolean | null = false;
	public disabledFlag: boolean | null = true;
	public activeCellId: string | null = '';

	/**** Query strip filter settings ***/
	public selectedStatusFilter: string | null = 'Active';
	public selectedViewFilter: string | null = 'List';
	public contentClassWithBanner: string | null = 'dwtable-container';
	public contentClassWithoutBanner: string | null = 'dwtable-container-without-header';
	public contentClassName: string | null = 'dwtable-container';

	/*** Record Table / card table  ***/
	public displayedColumns: string[] = ['id', 'agencyName', 'primaryContact', 'phoneNumber','emailAddress', 'activeStatus'];

	/***** Control Strip Button Visibility ***/
	public visibleAdd: boolean | null = false;
	public visibleModify: boolean | null = false;
	public visibleDelete: boolean | null = false;

	/***** Tab Detail Section *****/
	public selectedTabIndex: number | null = 0;
	public id: any | null = '';
	public agencyName: any | null = '';
	public agencyCode: any | null = '';
	public address1: any | null = '';
	public address2: any | null = '';
	public city: any | null = '';
	public state: any | null = '';
	public zipCode: any | null = '';
	public county: any | null = '';
	public primaryContact: any | null = '';
	public phoneNumber: any | null = '';
	public emailAddress: any | null = '';
	public activeStatus: string | null = '';

	/***** Side drawer ****/
	public propContainerState: boolean | null = false;
	public visiblePropertiesTab: boolean | null = true;
	public visibleNotesTab: boolean | null = true;

	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild('history', { static: true }) history: TransactionHistoryComponent;

	constructor(private agenciesService: AgenciesService,
		private txService: TransactionHistoryService,
		public dialog: MatDialog) {
		this.selectedRecord = new Agencies();

	}

	public ngOnInit() {
		if (Settings.getInstance().hasPrivilege('SETTINGS_AGENCY', "WRITE")) {
			this.visibleAdd = true;
			this.visibleModify = true;
			this.visibleDelete = false;
		}
	}

	public ngAfterContentInit() {

		this.queryRecords();

		if (Settings.getInstance().enableMessageBanner) {
			this.contentClassName = this.contentClassWithBanner;
		} else {
			this.contentClassName = this.contentClassWithoutBanner;
		}
	}
	/*** Query Records from the Service ***/
	public queryRecords() {

		this.agenciesService.getAllAgencies().subscribe(
			(result) => {
				this.records = result;
				this.dataSource = new MatTableDataSource(this.records);
				this.dataSource.sort = this.sort;
				this.onChangeStatusFilterValue();
				this.setPagination(-1, this.dataSource.data.length);
			},
			(error) => {
				Settings.getInstance().handleError('Error: unable to retrieve agencies data from the service');
			}
		);
	}
	/*** Display the number of records from the total ***/
	public setPagination(idx: number, total: number) {
		this.pagination = (idx + 1) + '/' + total;
	}
	public onChangeStatusFilterValue() {
		const dataTemp: Agencies[] = [];
		this.clearFilter();

		for (const rec of this.records) {
			if (rec.activeStatus === this.selectedStatusFilter || this.selectedStatusFilter === 'All') {
				dataTemp.push(rec);
			}
		}
		this.dataSource = new MatTableDataSource(dataTemp);
		this.setPagination(-1, this.dataSource.filteredData.length);
	}
	public onStatusChange() {

		this.agenciesService.updateAgencies(this.selectedRecord).subscribe(
			(data) => {
				// no user feedback, just apply the filter ...
				/*** add a transaction history record ***/
				const previousRecord = { ...this.selectedRecord };
				previousRecord.activeStatus = this.selectedRecord.activeStatus === "Active" ? "Inactive" : "Active";
				this.txService.updateTransactionHistory(previousRecord,
					this.selectedRecord, 'Agencies', this.selectedRecord.id);
				this.onChangeStatusFilterValue();
			});
	}
	public doTabChange(event): void {

	}
	@HostListener('matSortChange', ['$event'])
	public onSortChange(event: any) {

		const activeColumn = event.active;
		const direction = event.direction;

		// Check if the data in the active column is a number.
		// We'll check the first record for simplicity, assuming all values in the column are the same type.
		const isNumeric = typeof this.records[0][activeColumn] === 'number';

		this.records.sort((a, b) => {
			const valueA = a[activeColumn];
			const valueB = b[activeColumn];

			if (isNumeric) {
				// If it's a number, perform a numerical comparison.
				return direction === 'asc' ? valueA - valueB : valueB - valueA;
			} else {
				// If it's not a number (e.g., a string), use localeCompare().
				return direction === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
			}
		});

		this.dataSource.data = this.records;
		this.onChangeStatusFilterValue();
		this.selectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public clearFilter() {
		if (this.isEditing) {
			return;
		}
		this.unSelectRow();
		this.dataSource.filter = '';
		this.selectRow();
		this.setPagination(-1, this.dataSource.data.length);
	}
	public applyFilter(filterValue: string) {
		if (this.isEditing) {
			return;
		}
		this.dataSource.filter = filterValue.trim().toLowerCase();
		this.unSelectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public selectRow() {
		if (this.selectedRecord.id === 0) {
			this.unSelectRow();
			return;
		}
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
	}
	public unSelectRow() {

		this.Idx = -1;
		this.selectedRecord = new Agencies();
		this.setPagination(this.Idx, this.dataSource.data.length);
		this.displayDetail(this.selectedRecord);

	}
	public displayDetail(record: Agencies) {
		if (record === undefined) {
			return;
		}
		this.id = record.id;
		this.agencyName = record.agencyName;
		this.activeStatus = record.activeStatus.toString();
		this.agencyCode = record.agencyCode;
		this.address1 = record.address1;
		this.address2 = record.address2;
		this.city = record.city;
		this.state = record.state;
		this.zipCode = record.zipCode;
		this.county = record.county;
		this.primaryContact = record.primaryContact;
		this.phoneNumber = record.phoneNumber;
		this.emailAddress = record.emailAddress;

		this.history.onShowHandler('Agencies', 'id', record.id.toString());
	}
	public clear() {
		this.id = '';
		this.agencyName = '';
		this.activeStatus = '';
		this.agencyCode = '';
		this.address1 = '';
		this.address2 = '';
		this.city = '';
		this.state = '';
		this.zipCode = '';
		this.county = '';
		this.primaryContact = '';
		this.phoneNumber = '';
		this.emailAddress = '';
	}
	public addModifyRecord(isAdd: boolean) {
		this.isAdd = isAdd;
		this.isEditing = true;
		this.selectedTabIndex = 0;

		if (this.isAdd) {
			this.clear();
			this.id = 0;
			this.activeStatus = 'Active';
		} else {
			// store the history record
			this.historyRecord = this.selectedRecord;
		}
		DwUtils.setFocus('agencyName');
	}
	public removeRecord() {
		const message = 'Remove Agencies: "' + this.selectedRecord.agencyName + '" - Are you sure?';
		const dialogData = new ConfirmDialogModel('Please Confirm', message);

		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '400px',
			data: dialogData,
			panelClass: 'custom-dialog-container'
		});

		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			if (this.result === true) {
				this.agenciesService.deleteAgencies(this.selectedRecord.id).subscribe(
					(data) => {
						// remove the row from the table.

						this.records.splice(this.Idx, 1);
						this.dataSource.data = this.records;
						this.clear();
					},
					(error) => {
						Settings.getInstance().handleError(error);
					});
			}
		});
	}
	public onPropertiesToggle() {
		this.propContainerState = !this.propContainerState;
	}
	public tableKeyDown(event: KeyboardEvent) {
		if (this.isEditing) {
			return;
		}

		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selectedRecord = this.dataSource.filteredData[++this.Idx];
				this.displayDetail(this.selectedRecord);
			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selectedRecord = this.dataSource.filteredData[--this.Idx];
				this.displayDetail(this.selectedRecord);
			}
		}
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public validateFields(): boolean {

		this.strErr = '';
		const vr: ValidationResult = this.selectedRecord.validateRecord();

		if (vr.error.length > 0) {
			this.strErr = vr.error;
			DwUtils.setFocus(vr.focus_field);
			return false;
		}
		return true;
	}
	public submitRecord() {

		this.selectedRecord = new Agencies();
		this.selectedRecord.id = this.id;
		this.selectedRecord.agencyName = DwUtils.capitalize(this.agencyName);
		this.selectedRecord.agencyCode = this.agencyCode;
		this.selectedRecord.address1 = DwUtils.capitalize(this.address1);
		this.selectedRecord.address2 = DwUtils.capitalize(this.address2);
		this.selectedRecord.city = DwUtils.capitalize(this.city);
		this.selectedRecord.state = this.state.toUpperCase();
		this.selectedRecord.zipCode = this.zipCode;
		this.selectedRecord.county = DwUtils.capitalize(this.county);
		this.selectedRecord.activeStatus = this.activeStatus;
		this.selectedRecord.primaryContact = DwUtils.capitalize(this.primaryContact);
		this.selectedRecord.phoneNumber = this.phoneNumber;
		this.selectedRecord.emailAddress = this.emailAddress;

		this.strErr = '';

		if (!this.validateFields()) {
			return;
		}
		if (this.isAdd === true) {
			this.agenciesService.createAgencies(this.selectedRecord).subscribe(
				(data) => {
					this.selectedRecord.id = data.id;
					this.isEditing = false;
					/*** add a transaction history record ***/
					this.txService.createTransactionHistory('Agencies', this.selectedRecord.id);
				},
				(error) => {
					this.strErr = 'Error: The server could not add/submit this record';
					return;
				}
			);
		} else {

			this.agenciesService.updateAgencies(this.selectedRecord).subscribe(
				(data) => {
					this.isEditing = false;
				},
				(error) => {
					this.strErr = 'Error: The server could not update this record';
					this.selectedRecord = this.historyRecord;
					return;
				});

			/*** add a transaction history record ***/
			this.txService.updateTransactionHistory(this.historyRecord,
				this.selectedRecord, 'Agencies', this.selectedRecord.id);
		}
		this.updateSelectedRow();
	}
	/* Update the record in the table's data source - without refreshing it */
	public updateSelectedRow(): void {
		if (this.isAdd === true) {
			// add the new record to the top.
			this.records.unshift(this.selectedRecord);
			this.dataSource.data = this.records;
			this.Idx = 0;
		} else {
			const i: number = this.records.findIndex(r => r.id === this.selectedRecord.id);
			this.records[i] = this.selectedRecord;
			this.dataSource.data = this.records;

		}
		// do not apply the sort - it will whisk the record out of view
		// if there are large numbers of records.
		this.dataSource.sort = null;
	}
	public onRowClicked(selected: any) {

		if (this.isEditing === true)
			return;

		this.selectedRecord = selected;
		this.selectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
		this.displayDetail(this.selectedRecord);
	}
	public cancelSubmitRecord() {
		this.strErr = '';
		this.isEditing = false;
		this.displayDetail(this.selectedRecord);
	}
}
